/* This example requires Tailwind CSS v2.0+ */

import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment HeaderSimpleCenteredData on StrapiComponentHeaderSimpleCentered {
    title
    topic
    description
  }
`;

function SimpleCentered({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="text-center">
          {data.topic && (
            <h3 className="text-3xl tracking-tight text-text-white md:text-4xl">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.topic && (
            <h3 className="text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="mt-1 text-4xl font-extrabold text-text-primary sm:text-5xl sm:tracking-tight lg:text-6xl">
              <span>
                <MarkdownWrapper text={data.title} />
              </span>
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="max-w-xl mt-5 mx-auto text-xl text-text-secondary"
            />
          )}
        </div>
      </div>
    </div>
  );
}

SimpleCentered.propTypes = {
  data: PropTypes.object,
};

export default SimpleCentered;
